import { render } from "./MapPage.vue?vue&type=template&id=45235ea6&scoped=true"
import script from "./MapPage.vue?vue&type=script&lang=js"
export * from "./MapPage.vue?vue&type=script&lang=js"

import "./MapPage.vue?vue&type=style&index=0&id=45235ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45235ea6"]])

export default __exports__